module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraLight.428ffb5.woff";